import { typeCreatorV2 } from '../../../redux/utils/common';

//  [REDUCER][TYPE]
export const SET_VATRETURN_REMINDERS_LIST: string = typeCreatorV2(
  'VatReturnReminderReducer',
  'SetVatReturnRemindersList'
);

export const SET_VATRETURN_REMINDERS_TO_GENERATE: string = typeCreatorV2(
  'VatReturnReminderReducer',
  'SetVatReturnRemindersToGenerate'
);
